import { render, staticRenderFns } from "./AgregarPrepedido.vue?vue&type=template&id=5c7ab57e"
import script from "./AgregarPrepedido.vue?vue&type=script&lang=js"
export * from "./AgregarPrepedido.vue?vue&type=script&lang=js"
import style0 from "./AgregarPrepedido.vue?vue&type=style&index=0&id=5c7ab57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports